// "Tea Room" -> "TR", "tearoom" -> "T": a short monogram for tiny avatars
export function shopInitials(name) {
  const words = (name || '').replace(/^@/, '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '•';
  const letters = words.length > 1 ? words[0][0] + words[1][0] : words[0][0];
  return letters.toUpperCase();
}
